import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEN from '../locales/en/common.json';
import commonTR from '../locales/tr/common.json';
import navigationEN from '../locales/en/navigation.json';
import navigationTR from '../locales/tr/navigation.json';
import authEN from '../locales/en/auth.json';
import authTR from '../locales/tr/auth.json';
import dashboardEN from '../locales/en/dashboard.json';
import dashboardTR from '../locales/tr/dashboard.json';
import usersEN from '../locales/en/users.json';
import usersTR from '../locales/tr/users.json';
import eventsEN from '../locales/en/events.json';
import eventsTR from '../locales/tr/events.json';
import clubsEN from '../locales/en/clubs.json';
import clubsTR from '../locales/tr/clubs.json';
import universitiesEN from '../locales/en/universities.json';
import universitiesTR from '../locales/tr/universities.json';
import errorsEN from '../locales/en/errors.json';
import errorsTR from '../locales/tr/errors.json';
import validationEN from '../locales/en/validation.json';
import validationTR from '../locales/tr/validation.json';
import universityManagerEN from '../locales/en/universityManager.json';
import universityManagerTR from '../locales/tr/universityManager.json';
import staffEN from '../locales/en/staff.json';
import staffTR from '../locales/tr/staff.json';

const resources = {
  en: {
    common: commonEN,
    navigation: navigationEN,
    auth: authEN,
    dashboard: dashboardEN,
    users: usersEN,
    events: eventsEN,
    clubs: clubsEN,
    universities: universitiesEN,
    errors: errorsEN,
    validation: validationEN,
    universityManager: universityManagerEN,
    staff: staffEN,
  },
  tr: {
    common: commonTR,
    navigation: navigationTR,
    auth: authTR,
    dashboard: dashboardTR,
    users: usersTR,
    events: eventsTR,
    clubs: clubsTR,
    universities: universitiesTR,
    errors: errorsTR,
    validation: validationTR,
    universityManager: universityManagerTR,
    staff: staffTR,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'tr'],
    
    // Language detection options
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Default namespace
    defaultNS: 'common',
    
    // Debug mode (set to false in production)
    debug: false,

    react: {
      useSuspense: true,
    },
  });

export default i18n;
